import React, {forwardRef} from 'react'

import DropdownToggleInner from './DropdownToggleInner'
import DropdownToggleV2 from './DropdownToggleV2'













const NewMeetingDropdown = forwardRef((props, ref) => {
  const {className, icon, dropdownIcon, label, disabled, onClick, onMouseEnter, title, opened} =
    props
  return (
    React.createElement(DropdownToggleV2, {
      className: className,
      icon: dropdownIcon,
      onMouseEnter: onMouseEnter,
      onClick: onClick,
      disabled: disabled,
      ref: ref,
      opened: opened,}

      , React.createElement(DropdownToggleInner, { icon: icon, label: label, title: title,} )
    )
  )
})

export default NewMeetingDropdown
